import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Chart from 'chart.js/auto'
import Multiselect from 'vue-multiselect'
import App from './App.vue'
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })
Vue.config.productionTip = false

Vue.prototype.$chart = Chart

Vue.component('multiselect', Multiselect)

const requireComponent = require.context('./components/sections/', false, /section-[0-9]+\.vue$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/')
    .pop()
    .replace(/\.\w+$/, '')

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

if ('ontouchstart' in window) {
  document.body.classList.add('is-mobile')
  Vue.prototype.$animationEnable = false
} else {
  document.body.classList.add('is-desktop')
  Vue.prototype.$animationEnable = true
}

new Vue({
  render: h => h(App)
}).$mount('#app')
